import React from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react'

import Tick from 'assets/icons/tick.svg'
import TickIndeterminate from 'assets/icons/tick-indeterminate.svg'

import styles from './checkbox.scss'

interface IProps {
  className?: string
  checked?: boolean
  indeterminate?: boolean
  onChange?: (checked: boolean) => void
}

const Checkbox = ({
  className,
  checked = false,
  indeterminate = false,
  onChange,
}: IProps) => {
  return (
    <div
      data-cy="checkbox"
      data-cy-selected={checked}
      className={cn(styles.container, className)}
      onClick={() => onChange && onChange(!checked)}
    >
      <div className={cn(styles.checkbox, { [styles.checked]: checked })}>
        {checked && (indeterminate ? <TickIndeterminate /> : <Tick />)}
      </div>
    </div>
  )
}

export default observer(Checkbox)
